import { create } from 'zustand'

export interface IStoreState {
  previousRoute: string | null
  currentRoute: string | null
}

interface IStoreFunctions {
  setRoute: (route: string) => void
}

type Store = IStoreState & IStoreFunctions

const initialState: IStoreState = {
  previousRoute: null,
  currentRoute: null,
}

export const useRouteTrackerStore = create<Store>((set) => ({
  ...initialState,
  setRoute: (route: string) =>
    set((state) => ({
      previousRoute: state.currentRoute,
      currentRoute: route,
    })),
}))
